import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { forwardRef } from 'react'
import Tooltip from '@material-ui/core/Tooltip'
import clsx from 'clsx'
import { faExclamationTriangle, faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import useStyles from './styles'
import { SimpleInputProps } from './types'

const DarkInput = (
    {
        label,
        tooltipText,
        error,
        enableErrorIcon = false,
        className,
        themeColor,
        variant = 'primary',
        ...props
    }: SimpleInputProps,
    ref,
) => {
    const classes = useStyles()

    return (
        <div className={clsx(classes.formCtrl, className, classes[variant])}>
            <div className={clsx(classes.inputContainer)}>
                <input className={clsx(classes.input, classes.dark, classes[variant])} {...props} ref={ref} />
                {tooltipText && (
                    <Tooltip title={tooltipText} placement="left" enterTouchDelay={0}>
                        <div className={clsx(classes.infoDark)}>
                            <FontAwesomeIcon className={classes.infoDark} icon={faInfoCircle} />
                        </div>
                    </Tooltip>
                )}
            </div>

            {error && (
                <div className={clsx(classes.error, classes[variant])}>
                    {enableErrorIcon && <FontAwesomeIcon className={classes.errorIcon} icon={faExclamationTriangle} />}
                    {error}
                </div>
            )}
        </div>
    )
}

export default React.memo(forwardRef(DarkInput))
